import { render, staticRenderFns } from "./Product3.vue?vue&type=template&id=76975d50&"
import script from "./Product3.vue?vue&type=script&lang=js&"
export * from "./Product3.vue?vue&type=script&lang=js&"
import style0 from "./Product3.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports